import { render } from "./choose-type.vue?vue&type=template&id=6c9e1984&scoped=true&ts=true"
import script from "./choose-type.vue?vue&type=script&lang=ts"
export * from "./choose-type.vue?vue&type=script&lang=ts"

import "./choose-type.vue?vue&type=style&index=0&id=6c9e1984&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c9e1984"]])

export default __exports__